import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import { OneModal } from '@factorialco/f0-react/dist/experimental'

import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { useUpdateCatalog } from 'modules/trainings/hooks/Trainings/useUpdateCatalog'

interface UpdateCatalogProps {
  action: 'display' | 'hide'
  itemIds: number[]
  onClose: () => void
}

const UpdateCatalog = ({ action, itemIds, onClose }: UpdateCatalogProps) => {
  const { updateCatalog, loading } = useUpdateCatalog()

  const description =
    action === 'display'
      ? i18n.t('trainings.update_catalog.description_add_bulk')
      : i18n.t('trainings.update_catalog.description_remove_bulk')

  const onSubmit = async () => {
    const response = await updateCatalog({
      ids: itemIds,
      catalog: action === 'display',
    })

    const handled = handleResult(response, () => {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('trainings.update_catalog.error'),
      })
    })

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('trainings.update_catalog.success'),
      })
      onClose()
    }
  }

  return (
    <OneModal isOpen onClose={onClose}>
      <OneModal.Header title={i18n.t('trainings.update_catalog.title')} />
      <OneModal.Content withPadding>
        <Box gap="s8" flexDirection="column">
          <Text.Normal size="300">{description}</Text.Normal>
        </Box>
      </OneModal.Content>
      <OneModal.Footer>
        <Box flexDirection="row" gap="s12" justifyContent="flexEnd" width="full">
          <F0Button
            variant="outline"
            onClick={onClose}
            label={i18n.t('trainings.delete_training.cancel')}
          />
          <F0Button
            variant="default"
            onClick={onSubmit}
            label={i18n.t('trainings.delete_training.accept')}
            type="submit"
            loading={loading}
          />
        </Box>
      </OneModal.Footer>
    </OneModal>
  )
}

export default UpdateCatalog
